export default function () {
    const table = document.querySelector('table');
    if (!table) return;
    function collumnCounter(table) {
        const tr = table.querySelector('tr');
        if (!tr) return;
        const cellsInTr = tr.querySelectorAll('th');
        return cellsInTr.length;
    }

    const collumnCount = collumnCounter(table);

    const breakingPoints = table.querySelectorAll('.breakingpoint');
    breakingPoints.forEach(point => {
        if (point.previousElementSibling.classList.contains('breakingpoint')) return;

        const fakeTr = document.createElement('tr');
        fakeTr.classList.add('fake-tr');

        //const startingTd = document.createElement('td');

        const dateTd = document.createElement('td');
        dateTd.textContent = point.dataset.breakingpointValue
        dateTd.colSpan = collumnCount;
        //const fakeTd = document.createElement('td');
        //fakeTd.colSpan = collumnCount - 2;
        /*       fakeTr.insertAdjacentElement('afterbegin', fakeTd);*/
        fakeTr.insertAdjacentElement('afterbegin', dateTd);
        //fakeTr.insertAdjacentElement('afterbegin', startingTd);

        point.insertAdjacentElement('beforebegin', fakeTr);
    });
}